import React, {useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import { numToLetter} from "../../../../../../helpers/sqftHelper";
import {iconHeight, iconLength, iconLink} from "../../../../../../assetsSQFT";
import {changeMiteredSection} from "../../../../../../../../actions/sqftMiteredFunctions";
import workspace from "../../../../../canvas/core/workspace";
import {updateSQFTCalculations} from "../../../../../../../../actions/sqftFunctions";
import SlabWorkspace from "../../../../../canvas/core/slab/slabWorkspace";
import config from "../../../../../canvas/store/sqftConfig";

const SqftNavCustomBacksplashSegment = (props) => {
  const {backsplash, index} = props;
  const {updateCalculations, updateSQFTCalculations} = props;

  const line = workspace.getLineById(backsplash.attachedToId);
  const backsplashHeight = line.getBacksplashHeight();
  const lineLength = config.measureUnit === "Imperial" ? line.getLineLength() : line.getLineLengthMm(); //getTransformedMeasureUnit(15);
  const segmentMaxLength = 10000;
  const [heightValue, setHeightValue] = useState(backsplashHeight);

  const changeLength = (value) => {
    void value
  }

  const changeHeight = (value) => {
    line.setBacksplashHeight(value);
    setHeightValue(value);
    updateSQFTCalculations(updateCalculations + 1);
    SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(line);
  }

  return (
    <ul className="mitered-segment mitered-segment--double" data-id="${segment.id}">
      <li className="mitered-segment__content segment-height">
        <div className="segment-letter">{numToLetter(index + 1)}</div>
        <div className="segment-image">
          <img src={iconHeight} alt=""/>
        </div>
        <div className="segment-value">
          <input className="ui-input segment-value-input"
                 type="number"
                 min="0"
                 onChange={(e) => changeHeight(e.target.value)}
                 placeholder={heightValue}
                 value={heightValue} />
        </div>
        <div className="segment-description">
          <div>
            <img src={iconLink} alt=""/>
          </div>
          <div>
            height
          </div>
        </div>
      </li>
      <li className="mitered-segment__content segment-length">
        <div className="segment-image">
          <img src={iconLength} alt=""/>
        </div>
        <div className="segment-value">
          <input type="number"
                 max={segmentMaxLength}
                 min="0"
                 className="ui-input segment-value-input"
                 placeholder={lineLength}
                 value={lineLength}
                 disabled={true}
                 onChange={(e) => changeLength(e.target.value)} />
        </div>
        <div className="segment-description">
          length
        </div>
      </li>
    </ul>
  );
};

SqftNavCustomBacksplashSegment.propTypes = {
  backsplash: PropTypes.object,
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    updateCalculations: store.sqftState.updateCalculations,
  };
};

const mapDispatchToProps = {
  changeMiteredSection,
  updateSQFTCalculations,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavCustomBacksplashSegment);
